
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

interface HeroProps {
  lang: string;
}

export function Hero({ lang }: HeroProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="hero-section">
      <div 
        className="hero-background"
        style={{ backgroundImage: `url('/lovable-uploads/a55d3b3a-49ce-4026-ae17-6704bd05f042.png')` }}
      ></div>
      <div className="hero-content flex flex-col items-center justify-center text-center">
        <h1 className="hero-title animate-fade-in">
          {t('home.hero.title')}
        </h1>
        <p className="hero-description animate-fade-in">
          {t('home.hero.description')}
        </p>
        <div className="flex gap-4 animate-fade-in">
          <Button 
            onClick={() => navigate(`/${lang === 'en' ? '' : lang + '/'}courses`)}
            className="group flex items-center gap-2 bg-primary hover:bg-primary/90 text-white"
          >
            {t('home.hero.cta')}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Button>
          <Button 
            variant="outline"
            onClick={() => navigate(`/${lang === 'en' ? '' : lang + '/'}blog`)}
            className="border-white/20 text-foreground hover:text-primary hover:border-primary"
          >
            {t('home.hero.secondary')}
          </Button>
        </div>
      </div>
    </div>
  );
}
